GeneralInfoRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function GeneralInfoRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/GeneralInfo/List");

    $stateProvider

        .state('GeneralInfo', {

            abstract: true,

            url: '/GeneralInfo',

            template: '<ui-view id="GeneralInfo"></ui-view>'

        })

        .state('GeneralInfo.List', {

            url: '/List',

            controller: 'GeneralInfo.ListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./List/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./List/List.module');

                        $ocLazyLoad.load({

                            name: 'ListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "تکمیل اطلاعات",
                icon: "fas fa-tasks"
            }

        })
        .state('GeneralInfo.JobExperience', {

            url: '/JobExperience',

            controller: 'GeneralInfo.JobExperienceController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./JobExperience/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./JobExperience/JobExperience.module');

                        $ocLazyLoad.load({

                            name: 'JobExperienceModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "سوابق کاری",
                icon: "fas fa-sitemap"
            }

        })
        .state('GeneralInfo.Certificates', {

            url: '/Certificates',

            controller: 'GeneralInfo.CertificatesController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Certificates/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Certificates/Certificates.module');

                        $ocLazyLoad.load({

                            name: 'CertificatesModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "گواهینامه ها",
                icon: "fas fa-object-group"
            }

        })
        .state('GeneralInfo.TeachingHistory', {

            url: '/TeachingHistory',

            controller: 'GeneralInfo.TeachingHistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./TeachingHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./TeachingHistory/TeachingHistory.module');

                        $ocLazyLoad.load({

                            name: 'TeachingHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "سوابق تدریسی",
                icon: "fas fa-university"
            }

        })
        .state('GeneralInfo.EducationalHistory', {

            url: '/EducationalHistory',

            controller: 'GeneralInfo.EducationalHistoryController',

            controllerAs: 'self',


            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./EducationalHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./EducationalHistory/EducationalHistory.module');

                        $ocLazyLoad.load({

                            name: 'EducationalHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "سوابق تحصیلی",
                icon: "fas fa-university"
            }

        })
        .state('GeneralInfo.Skillhistory', {

            url: '/Skillhistory',

            controller: 'GeneralInfo.SkillhistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Skillhistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Skillhistory/Skillhistory.module');

                        $ocLazyLoad.load({

                            name: 'SkillhistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "سوابق مهارتی",
                icon: "fas fa-university"
            }

        })
        .state('GeneralInfo.ResearchHistory', {

            url: '/ResearchHistory',

            controller: 'GeneralInfo.ResearchHistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ResearchHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ResearchHistory/ResearchHistory.module');

                        $ocLazyLoad.load({

                            name: 'ResearchHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "سوابق پژوهشی",
                icon: "fas fa-search"
            }

        })
        .state('GeneralInfo.UploadDocument', {

            url: '/UploadDocument',

            controller: 'GeneralInfo.UploadDocumentController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./UploadDocument/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./UploadDocument/UploadDocument.module');

                        $ocLazyLoad.load({

                            name: 'UploadDocumentModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "بارگزاری مستندات",
                icon: "fas fa-upload"
            }

        })
        .state('GeneralInfo.Inventions', {

            url: '/Inventions',

            controller: 'GeneralInfo.InventionsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Inventions/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Inventions/Inventions.module');

                        $ocLazyLoad.load({

                            name: 'InventionsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "اختراعات",
                icon: "fas fa-file"
            }

        })
        .state('GeneralInfo.Acknowledgments', {

            url: '/Acknowledgments',

            controller: 'GeneralInfo.AcknowledgmentsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Acknowledgments/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Acknowledgments/Acknowledgments.module');

                        $ocLazyLoad.load({

                            name: 'AcknowledgmentsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "تقدیرنامه",
                icon: "fas fa-file"
            }

        })
        .state('GeneralInfo.Contact', {

            url: '/Contact',
            
            controller: 'GeneralInfo.ContactController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Contact/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Contact/Contact.module');

                        $ocLazyLoad.load({

                            name: 'ContactModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Support', {

            url: '/Support',

            controller: 'GeneralInfo.SupportController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Support/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Support/Support.module');

                        $ocLazyLoad.load({

                            name: 'SupportModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "پشتیبانی",
                icon: "fas fa-question"
            }

        })
        .state('GeneralInfo.Favorites', {

            url: '/Favorites',

            controller: 'GeneralInfo.FavoritesController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Favorites/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Favorites/Favorites.module');

                        $ocLazyLoad.load({

                            name: 'FavoritesModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "علاقه مندی ها",
                icon: "fas fa-star"
            }

        })
        .state('GeneralInfo.Skills', {

            url: '/Skills',

            controller: 'GeneralInfo.SkillsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Skills/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Skills/Skills.module');

                        $ocLazyLoad.load({

                            name: 'SkillsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "مهارت ها",
                icon: "fas fa-certificate"
            }

        }) /*endOfResolve*/ ;

}



export default GeneralInfoRouting;